module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibold.0f3da1ed.eot";